// Per-URL title, description, canonical and robots tags for the marketing site.
// The server writes the same tags into index.html (server/src/seo.js), so
// crawlers see them before any JavaScript runs; this keeps them in sync while
// visitors navigate client-side.
import SEO from '../data/seo.json';

export const MARKETING_SLUGS = Object.keys(SEO.pages);

export const slugFromPath = (pathname = window.location.pathname) => {
  const slug = pathname.replace(/^\/+|\/+$/g, '');
  return slug === '' ? 'home' : slug;
};

const meta = (attr, key) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) { el = document.createElement('meta'); el.setAttribute(attr, key); document.head.appendChild(el); }
  return el;
};

export function applySeo(slug) {
  const page = slug === 'home' ? { ...SEO.home, index: true } : SEO.pages[slug];
  const url = SEO.site + (slug === 'home' ? '/' : `/${slug}`);
  document.title = page?.title || 'Page not found · skrl';
  meta('name', 'description').content = page?.description || SEO.home.description;
  meta('name', 'robots').content = page?.index ? 'index, follow' : 'noindex, follow';
  meta('property', 'og:title').content = document.title;
  meta('property', 'og:description').content = meta('name', 'description').content;
  meta('property', 'og:url').content = url;
  let link = document.head.querySelector('link[rel="canonical"]');
  if (!link) { link = document.createElement('link'); link.rel = 'canonical'; document.head.appendChild(link); }
  link.href = url;
}
